import { useState } from 'react';

import { Modal, Text, Textarea } from '@thefarmersfront/kitchen';

import { InfoText } from '~/components/common';

import styles from './DeliveryAgencyExcelDownloadModal.module.scss';

const DeliveryAgencyExcelDownloadModal = ({
  type,
  open,
  onCancel,
  onConfirm,
}: {
  type: '주문' | '운송장';
  open: boolean;
  onCancel: () => void;
  onConfirm: (reason: string) => void;
}) => {
  const [reason, setReason] = useState('');

  return (
    <Modal
      title={`${type} 엑셀 전체 다운로드`}
      size="small"
      confirmText="다운로드"
      disabled={reason.trim().length === 0}
      open={open}
      onConfirm={() => onConfirm(reason)}
      onCancel={onCancel}
    >
      <div className={styles['contents-container']}>
        <Textarea
          size="small"
          placeholder="다운로드 사유 입력"
          count
          maxLength={50}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          onBlur={(e) => setReason(e.target.value.trim())}
        />
        <div className={styles['info-section']}>
          <InfoText>
            <div>
              <Text size="small" color="secondary" weight="semi-bold" element="span">
                엑셀 파일이 꼭 필요하신가요?{' '}
              </Text>
              <Text size="small" color="secondary" element="span">
                주문 관리 외 다른 목적으로 이용할 수 없으며,
              </Text>
            </div>
            <Text size="small" color="secondary" element="span">
              업무 처리를 위해 불가피한 경우에 한해 다운로드 해주세요.
            </Text>
          </InfoText>
          <InfoText>
            개인정보 유출 시 관련 법령에 따른 책임이 발생할 수 있으니 파일을 안전하게 보관/관리/파기해주세요.
          </InfoText>
          <InfoText>
            <Text size="small" color="secondary" element="span">
              다운로드된 파일은 접속하신{' '}
            </Text>
            <Text size="small" color="secondary" weight="semi-bold" element="span">
              [로그인ID]
            </Text>
            <Text size="small" color="secondary" element="span">
              로 암호화되어 있습니다.
            </Text>
          </InfoText>
        </div>
      </div>
    </Modal>
  );
};

export default DeliveryAgencyExcelDownloadModal;
